import { csx, cx } from '@vtex/admin-ui'
import type { HTMLAttributes } from 'react'
import React from 'react'

export type ProductPageRootProps = HTMLAttributes<HTMLDivElement>

export const ProductPageRoot = ({
  children,
  className = '',
  ...props
}: ProductPageRootProps) => (
  <div
    className={cx(
      csx({
        display: 'grid',
        gap: '$space-6',
        gridTemplateColumns: '1fr',
        '@desktop': {
          gridTemplateColumns: '1fr 380px',
          gap: '$space-10',
        },
      }),
      className
    )}
    {...props}
  >
    {children}
  </div>
)
